import { FC, useState } from 'react';
import { AIMessage } from './Message';
import { MessageRole, useSendFeedback } from '../hooks';
import { Icon } from 'Components/UI';
import { Button } from 'antd';
import { StateTextArea } from 'Components/UI/Textarea';
import { default as MaletaButton } from 'Components/UI/Button';
import SpinCustom from 'Components/UI/SpinCustom';
import toastHandler from '../../../../../../Utils/toastHandler';
import { AI_STREAM_MESSAGE_PREFIX } from '../../Utils/constants';

import styles from './Messages.module.scss';
import { Mixpanel } from 'Utils/MixPanel';

export const FeebackRow: FC<AIMessage> = ({ role, content, threadId, messageId }) => {
  const [feedback, setFeedback] = useState<string | undefined>(undefined);
  const [positiveFeedbackGiven, setPositiveFeedbackGiven] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const { mutateAsync: mutateAsyncSendFeedback, isPending } = useSendFeedback();

  const handleOpenFeedback = () => {
    setOpenFeedback((open) => !open);

    setTimeout(() => {
      const chatContainer = window.document.getElementById('chat-container');
      chatContainer?.scrollTo({ top: chatContainer?.scrollHeight, behavior: 'smooth' });
    }, 1);
  };

  const handlePositiveFeedback = () => {
    if (positiveFeedbackGiven) return;

    toastHandler.showSuccess(`Muito obrigado pelo feedback!`);
    setPositiveFeedbackGiven(true);
    Mixpanel.track({
      name: 'AI_POSITIVE_FEEDBACK',
      props: { threadId, messageId }
    });
  };

  const isStreaming = messageId.startsWith(AI_STREAM_MESSAGE_PREFIX);
  if (isStreaming) {
    return <></>;
  }

  return (
    <>
      {role === MessageRole.BOT && (
        <div>
          <div className={styles['actions']}>
            <Button
              type="text"
              onClick={() => {
                navigator.clipboard.writeText(content);
              }}
            >
              <Icon icon="copiar" />
            </Button>

            <Button
              type="text"
              className={positiveFeedbackGiven ? styles['selectedButton'] : ''}
            >
              <Icon icon="ThumbsUp" onClick={handlePositiveFeedback} />
            </Button>

            <Button type="text" className={openFeedback ? styles['selectedButton'] : ''}>
              <Icon icon="ThumbsDown" onClick={handleOpenFeedback} />
            </Button>
          </div>

          {openFeedback && threadId && messageId && (
            <div className={styles['feedbackContainer']}>
              <StateTextArea
                label=""
                name="feedback"
                style={{ minHeight: '180px' }}
                placeholder="Digite seu feedback..."
                value={feedback}
                onChange={(e: any) => setFeedback(e.target.value)}
              />
              <MaletaButton
                type="text"
                className={styles['feedbackButton']}
                onClick={async () => {
                  const response = await mutateAsyncSendFeedback({
                    comments: feedback || '',
                    threadId,
                    messageId
                  });

                  if (response.success) {
                    setFeedback('');
                    setOpenFeedback(false);
                    toastHandler.showSuccess(`Seu feedback foi enviado com sucesso!`);
                  } else {
                    toastHandler.showError('Oops, algo deu errado ao enviar o feedback');
                  }
                }}
              >
                {isPending ? (
                  <span className={styles['loadingButton']}>
                    <SpinCustom />
                    Enviando...
                  </span>
                ) : (
                  'Enviar feedback'
                )}
              </MaletaButton>
            </div>
          )}
        </div>
      )}
    </>
  );
};
